module.exports = __webpack_public_path__ + "img/balzac.d05cfec1.jpg";